import {Injectable} from '@angular/core';
import {Http, RequestOptions, Headers, Response, ResponseContentType} from '@angular/http';
import {TokenManagerService} from 'app/shared/services/token-login.service';
import {GenerateInviteCodes, UpdateMembersMaxInvites} from './invite-management.model';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {HttpRequestService} from '../../shared/services/http-request.service';


@Injectable()
export class InviteManagementService {

  private getInviteManagementURL = environment.apiUrl + '/MemberCms/GetInviteManagement';
  private updateMembersMaxInvitesURL = environment.apiUrl + '/MemberCms/UpdateMembersMaxInvites';
  private generateInviteCodesURL = environment.apiUrl + '/MemberCms/GenerateInviteCodes';
  private updateInvitePolicyURL = environment.apiUrl + '/MemberCms/UpdateInvitePolicy';

  constructor(private http: Http, private _http: HttpRequestService) {}

  getInviteManagement() {
    return this._http.get(this.getInviteManagementURL);
  }

  updateMembersMaxInvites(membersMaxInvites: UpdateMembersMaxInvites) {
    return this._http.post(this.updateMembersMaxInvitesURL, membersMaxInvites);
  }

  generateInviteCodes(generateInviteCodesModel: GenerateInviteCodes) {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    headers.append('Authorization', JSON.parse(TokenManagerService.getToken()).token);
    const options = new RequestOptions({headers: headers});

    return this.http.post(this.generateInviteCodesURL, generateInviteCodesModel, {headers: headers, responseType: ResponseContentType.Blob})
    .map( res => res.blob());
  }

  updateInvitePolicy(value: string) {
    return this._http.get(this.updateInvitePolicyURL + '?invitePolicyValue=' + value);
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/invite-management/invite-management.service.ts